import React from 'react'
import { connect } from 'react-redux'
import { setGlobalLoading } from 'redux/actions/actionCommon'
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import { INTEGRATIONTOP } from '../../Includes/ConstArray';
import { addHyphen } from 'utlis/helpers/Common/Helper';
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';


function IntegrationCard(props) {
    // store url
    const [storeUrl] = useStoreUrl()
    
    return (

        <div className="d-flex">
            {INTEGRATIONTOP.map((e, index) =>
                <div className="app-card" key={index}>
                    <Link to={`${storeUrl}/settings/integration/${addHyphen(e.title || "")}`}>
                        <div className="app-card-content border st-default-rounded-block bg-white">
                            <div className="d-flex flex-wrap  align-items-center justify-content-center">
                                <span className="pad-12 app-integrations-icon">
                                    <FeatherIcon
                                        icon="bar-chart"
                                        size="26"
                                        className="icon text-primary" />
                                </span>
                                <div className="app-header-wrapper heading-md d-flex flex-column justify-content-center text-center mb-0">
                                    <p className="integrations-heading">{e.title}</p>
                                    <p className="integrations-desc">{e.sub_title}</p>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
            )}
        </div>
    )
}

const getDataFromStore = state => {
    return {
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(IntegrationCard)